module.exports = __webpack_public_path__ + "a428a00bece5e565841ba6ba44ba5d9f.MP3";